import { useEffect, useState } from "react";

function TimeLeftTimer({ targetTime }) {
    const [timeLeft, setTimeLeft] = useState("--:--:--");

    useEffect(() => {
        if (!targetTime) return;

        const calculateTimeLeft = () => {
            const targetDate = new Date(targetTime);
            const now = new Date();
            const duration = targetDate - now;

            const hours = Math.floor(duration / (1000 * 60 * 60));
            const minutes = Math.floor(duration % (1000 * 60 * 60) / (1000 * 60));
            const seconds = Math.floor(duration % (1000 * 60) / 1000);
            return { hours, minutes, seconds };
        };

        const updateTimer = () => {
            const newTime = calculateTimeLeft();
            setTimeLeft(newTime);
        };

        updateTimer();
        const timerId = setInterval(updateTimer, 1000);
        return () => clearInterval(timerId);
    }, [targetTime]);

    const formatTime = () => {
            const parts = [];
            const hours = timeLeft.hours;
            const minutes = timeLeft.minutes;
            const seconds = timeLeft.seconds;

            if (hours <= 0 && minutes <= 0 && seconds <= 0) {
                return "✅";
            };

            if (hours > 0) parts.push(`${hours}ч.`);
            if (minutes > 0) parts.push(`${minutes}м.`);
            parts.push(`${seconds}с.`);
            return parts.join(" ");
        };
    
    return (
        <div className="timer">
            {formatTime()}
        </div>
    );
};

export default TimeLeftTimer;